import { useDispatch } from "react-redux";
import { updateViewportWidth } from "redux/actions/App";

import useResizeObserver from "hooks/App/Observers/ResizeObserver";

export default function useScreenResize() {

    const appRef = document.getElementsByClassName('App')[0];
    const dispatch = useDispatch();

    const handleWidthChange = (entries) => {
        const entry = entries.slice(-1)[0];
        const width = entry.borderBoxSize?.[0].inlineSize;
        if (width) {
            dispatch(updateViewportWidth(width));
        }
    }
    
    useResizeObserver(appRef, handleWidthChange);

    return { appRef };
}